import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, FieldText } from '@dixa/lib-shared-habla';
import { useCallback, useRef } from 'react';
import { Field, FieldArray, } from 'redux-form';
import { FieldRepeater, RepeaterDivider } from 'fable/fieldRepeater';
import { useScrollToLastChild } from 'hooks/useScrollToLastChild';
import { PhoneNumber } from './phoneNumber';
import styles from './rules.module.scss';
export const MATCHINGS_FIELD = 'matchings';
export const NAME_FIELD = 'name';
export function Rules({ fields, rules, }) {
    const locationsDiv = useRef(null);
    useScrollToLastChild(locationsDiv, rules);
    const handleAddNewLocation = useCallback(() => {
        const INIT_LOCATION_FIELD = {
            matchings: [{ type: 'full-number', rule: 'prefix', match: '' }],
            name: '',
            rule_type: 'any',
        };
        fields.push(INIT_LOCATION_FIELD);
    }, [fields, rules]);
    const handleLocationsRemove = useCallback((index) => {
        const { matchings } = rules[index];
        if (matchings.length === 1) {
            fields.remove(index);
        }
    }, [fields, rules]);
    const isOnlyNumber = rules.length === 1 && rules[0].matchings.length === 1;
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.locations, ref: locationsDiv }, { children: fields.map((field, index) => (_jsxs("div", Object.assign({ className: styles.location }, { children: [_jsxs("div", Object.assign({ className: styles.header }, { children: ["Locations #", index + 1] })), _jsx(Field, { className: styles.name, component: FieldText, helpIcon: {
                                text: 'A name will make it easier for you to identify which country codes and/or phone numbers are connected to specific queues (e.g. the London office, Germany, the East Coast, Tuscany, etc.).',
                            }, label: "Name", name: `${field}.${NAME_FIELD}`, placeholder: "Location name (e.g. London or Germany)" }), _jsx(FieldArray, { buttonProps: { placement: 'bottom', label: 'Add phone number' }, className: styles.phoneNumbers, component: FieldRepeater, defaultRowProps: {
                                type: 'full-number',
                                rule: 'prefix',
                                match: '',
                            }, divider: _jsx(RepeaterDivider, {}), rowProps: {
                                isOnlyNumber,
                                onPhoneNumberRemove: () => handleLocationsRemove(index),
                            }, name: `${field}.${MATCHINGS_FIELD}`, rowComponent: PhoneNumber, style: { maxHeight: 'none', paddingTop: 0 }, withBackground: false }, index)] }), `${field}-${index}`))) })), _jsx(Button, Object.assign({ className: styles.button, onClick: handleAddNewLocation, type: "button", variant: "secondary" }, { children: "Add new location" }))] }));
}
